import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';
import {
	fetchGuides,
	fetchGuidesByOrganizationModule,
	clearGuides,
} from '@resources/Guide/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { moduleByParam } from '@common/utils/module';
import { GuideItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';
import DetailModal from './Detail';

const { Content } = Layout;

const Guide = (props) => {
	const {
		guides,
		fetchGuides,
		fetchGuidesByOrganizationModule,
		fetchModulesBySubmoduleCode,
		clearGuides,
		match,
		organization,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);
	const [detail, setDetail] = useState(false);
	const [module, setModule] = useState({});

	useEffect(() => {
		const func = async () => {
			const { data } = await fetchModulesBySubmoduleCode('guide');
			await clearGuides();
			const param = match?.params || {};
			const modByParam = moduleByParam(data?.data, param);

			setModule(modByParam);

			organization?._id && modByParam
				? await fetchGuidesByOrganizationModule(
						organization?._id,
						modByParam && modByParam._id,
						param[`moduleId`]
				  )
				: await fetchGuides();
		};

		func();
	}, [
		fetchGuides,
		fetchGuidesByOrganizationModule,
		fetchModulesBySubmoduleCode,
		clearGuides,
		organization,
	]);

	const parseDataSource = useCallback(() => {
		return guides.map((guide) => {
			return {
				key: guide._id,
				...guide,
			};
		});
	}, [guides]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.guide.management',
						defaultMessage: 'Guide Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>

			<DetailModal
				{...props}
				module={module}
				visible={detail}
				onCancel={() => setDetail(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.guides"
									defaultMessage="Guides"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.guide"
									defaultMessage="New Guide"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((guide, index) => (
							<GuideItem
								key={`guide-${index}`}
								guide={guide}
								onEdit={() => setUpdate(guide._id)}
								onClick={() => setDetail(guide._id)}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	guides,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		guides,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchGuides,
	fetchGuidesByOrganizationModule,
	fetchModulesBySubmoduleCode,
	clearGuides,
})(Guide);
